import { render, staticRenderFns } from "./Amtb.vue?vue&type=template&id=0e907e22&"
import script from "./Amtb.vue?vue&type=script&lang=js&"
export * from "./Amtb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports